// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@property --masked-scroll-area-mask-distance-start {
  syntax: '<length>';
  inherits: false;
  initial-value: 0rem;
}

@property --masked-scroll-area-mask-distance-end {
  syntax: '<length>';
  inherits: false;
  initial-value: 0rem;
}

.masked-scroll-area {
  --masked-scroll-area-mask-distance-start: 0rem;
  --masked-scroll-area-mask-distance-end: 0rem;
  --masked-scroll-area-mask-direction: to right;
  /* Remove transition */
  /* transition:
    --masked-scroll-area-mask-distance-start 0.2s,
    --masked-scroll-area-mask-distance-end 0.2s,
    --masked-scroll-area-mask-direction 0.2s; */
  mask: linear-gradient(
    var(--masked-scroll-area-mask-direction),
    transparent,
    black var(--masked-scroll-area-mask-distance-start),
    black calc(100% - var(--masked-scroll-area-mask-distance-end)),
    transparent
  );
}

.masked-scroll-area-nav-button-start,
.masked-scroll-area-nav-button-end {
  transition: opacity 0.2s ease;
  position: absolute;
}
.masked-scroll-area-nav-button-hover {
  opacity: 0;
}
.masked-scroll-area-container:hover > .masked-scroll-area-nav-button-hover {
  opacity: 1;
}
.masked-scroll-area-container.is-at-start
  > .masked-scroll-area-nav-button-start {
  display: none;
}
.masked-scroll-area-container.is-at-end > .masked-scroll-area-nav-button-end {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/embedded/chat/components/masked-scrollarea/index.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,4CAA4C;EAC5C,6CAA6C;EAC7C,sBAAsB;EACtB;;;+CAG6C;EAC7C;;;;;;GAMC;AACH;;AAEA;;EAEE,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;EACE,aAAa;AACf","sourcesContent":["@property --masked-scroll-area-mask-distance-start {\n  syntax: '<length>';\n  inherits: false;\n  initial-value: 0rem;\n}\n\n@property --masked-scroll-area-mask-distance-end {\n  syntax: '<length>';\n  inherits: false;\n  initial-value: 0rem;\n}\n\n.masked-scroll-area {\n  --masked-scroll-area-mask-distance-start: 0rem;\n  --masked-scroll-area-mask-distance-end: 0rem;\n  --masked-scroll-area-mask-direction: to right;\n  /* Remove transition */\n  /* transition:\n    --masked-scroll-area-mask-distance-start 0.2s,\n    --masked-scroll-area-mask-distance-end 0.2s,\n    --masked-scroll-area-mask-direction 0.2s; */\n  mask: linear-gradient(\n    var(--masked-scroll-area-mask-direction),\n    transparent,\n    black var(--masked-scroll-area-mask-distance-start),\n    black calc(100% - var(--masked-scroll-area-mask-distance-end)),\n    transparent\n  );\n}\n\n.masked-scroll-area-nav-button-start,\n.masked-scroll-area-nav-button-end {\n  transition: opacity 0.2s ease;\n  position: absolute;\n}\n.masked-scroll-area-nav-button-hover {\n  opacity: 0;\n}\n.masked-scroll-area-container:hover > .masked-scroll-area-nav-button-hover {\n  opacity: 1;\n}\n.masked-scroll-area-container.is-at-start\n  > .masked-scroll-area-nav-button-start {\n  display: none;\n}\n.masked-scroll-area-container.is-at-end > .masked-scroll-area-nav-button-end {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
